var render, staticRenderFns
import script from "./chart-value.vue?vue&type=script&lang=js&"
export * from "./chart-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d67bc",
  null
  
)

export default component.exports